<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键词" name='keyword'>
      <a-input v-model:value="search.keyword" style="width:270px" placeholder="请输入卡券名称/ID进行搜索" />
    </a-form-item>
    <a-form-item label="券状态" name='status'>
      <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="1">正常</a-select-option>
        <a-select-option :value="0">失效</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="券类型" name='coupon_type'>
      <a-select v-model:value="search.coupon_type" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option :value="2">现金券</a-select-option>
        <a-select-option :value="3">代金券</a-select-option>
        <a-select-option :value="1">折扣券</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
    <!-- <a-form-item>
      <a-button type="primary" ghost>导出</a-button>
    </a-form-item> -->
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a v-has:couponStatisticsDetails="()=> {$router.push('/assets/coupons/couponCard/statisticsDetailed?id='+record.id)}"  href="javascript:;" >查看详情</a>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
    :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
    @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
  import {  ExclamationCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs, createVNode,h } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { couponStatistics } from "@/api/assets";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    keyword: "",
    status: '',
    page: 1,
    limit: 10,
    coupon_type: ''
  };
  export default {
    name: 'statistics',
    components: { },
    setup() {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        total: 1
      });
      let columns = [
      {
          title: "卡券ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "券类型",
          dataIndex: "coupon_type_text",
          key: "coupon_type_text",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
        },
        {
          title: "有效期",
          key: "valid_period_time",
          dataIndex:'valid_period_time'
        },
        
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          customRender: ({ record }) => {
            return record.remark ? record.remark : '-'
          }
        },
        {
          title: "发放数量",
          dataIndex: "receive_num",
          key: "receive_num",
        },
        {
          title: "使用数量",
          dataIndex: "use_num",
          key: "use_num",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await couponStatistics(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          }
        } catch (e) {
          state.listLoading = false;
        }
      };


      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
      };
    },
  };
</script>